<template>
  <div class="apis-list">
    <v-banner color="error" dark v-if="fetchAllError">
      <v-icon slot="icon" color="white" size="36">mdi-wifi-strength-alert-outline</v-icon>
      {{ errorDisplay(fetchAllError) }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="fetchAll">Retry</v-btn>
      </template>
    </v-banner>
    <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span>On this page you can display all APIs. You can add, edit or delete APIs. Each API has several settings:</span>
        <ul>
          <li><strong>Client ID</strong>: must begin with 'api-' prefix. This is the string that will be used in your API to verify token validity and user rights.</li>
          <li><strong>Client Secret</strong>: will be automatically generated when creating a new API. You need this credential to verify token validity and user rights.</li>
          <li><strong>Name</strong>: human readable name of API for documentation purposes.</li>
          <li><strong>Description</strong>: quick overview of API functionalities.</li>
          <li><strong>Root URL</strong>: fill out with API url to swagger documentation, removing '/ui', in order to display swagger inside this application (https://api.example.taster.com/v1).</li>
          <li><strong>Redirect URI</strong>: fill out with '*'.</li>
          <li><strong>Web origins</strong>: set of different URIs in order to handle oauth2 on API swagger. Must reference API URL, followed by '*' (https://api.example.taster.com/*). You can add multiple web origins, espacially for tests purposes (e.g. http://localhost:8080/*).</li>
        </ul>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{displayInfo ?'Hide':'Show'}}</v-btn>
      </template>
    </v-banner>
    <v-container>
      <APIsTable
        v-on:refresh="refresh"
        v-on:createNew="openApiCreationDialog"
        v-on:editApi="goToApiDetails"
        v-on:deleteApi="openApiDeletionDialog"
      />
      <APICreationDialog
        :dialog="creationDialog"
        v-on:cancel="creationDialog = false"
        v-on:save="createApi"
        ref="creationDialog"
      />
      <APIDeletionDialog
        :api="selectedAPI"
        :dialog="deletionDialog"
        v-on:cancel="deletionDialog = false"
        v-on:deleteApi="deleteApi"
      />
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import APIsTable from "@/components/Admin/APIs/APIsTable";
import APICreationDialog from "@/components/Admin/APIs/APICreationDialog";
import APIDeletionDialog from "@/components/Admin/APIs/APIDeletionDialog";

export default {
  name: "APIsList",
  components: { APIsTable, APICreationDialog, APIDeletionDialog },
  mixins: [mixin],
  data() {
    return {
      creationDialog: false,
      deletionDialog: false,
      selectedAPI: {},
      snackbar: false,
      errorMessage: "",
      displayInfo: false
    };
  },
  computed: {
    ...mapState({
      apis: state => state.apis.all,
      fetchAllLoading: state => state.apis.fetchAll.pending,
      fetchAllError: state => state.apis.fetchAll.error
    })
  },
  methods: {
    ...mapActions("apis", { fetchAll: "fetchAll" }),
    ...mapActions("apis", { createOne: "createOne" }),
    ...mapActions("apis", { deleteOne: "deleteOne" }),
    refresh() {
      this.fetchAll();
    },
    openApiCreationDialog() {
      this.creationDialog = true;
    },
    openApiDeletionDialog(api) {
      this.selectedAPI = api;
      this.deletionDialog = true;
    },
    goToApiDetails(api) {
      this.$router.push(`/admin/apis/${api.uuid}`);
    },
    createApi(id, name, description, rootUrl) {
      this.createOne({
        id: id,
        name: name,
        description: description,
        url: rootUrl,
        redirectUris: [],
        webOrigins: []
      })
        .then(() => {
          this.refresh();
          this.creationDialog = false;
          this.$refs.creationDialog.reset();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteApi(uuid) {
      this.deleteOne({ uuid: uuid })
        .then(() => {
          this.deletionDialog = false;
          this.selectedAPI = {};
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.fetchAll();
  }
};
</script>